<template>
  <div>
    <div>
      <div class="fp-headshot"><img :src="'./assets/headshots/' + d.headshot + '.png'"></div>
      <div class="block-meta name">{{ d.name }}</div>
      <div class="block-meta age" v-if="d.age">Age {{ d.age }}</div>
      <div class="block-meta location" v-if="d.location">{{ d.location }}</div>
      <div class="button first-person-button"><a :href="d.url">{{ d.button_language }}</a></div>
    </div>
  </div>
</template>

<script>
  module.exports = {
    props: ['d'],
    methods: {
    },
  }
</script>

<style scoped></style>
